export function validateName(fieldName, value) {
    const length = value.length;
    const name  = fieldName === "firstName" ? "First Name" : "Last Name";
    if( length < 1 ) {
        return {
            isValid : false,
            message : `Error: Please enter your ${name}.`
        }
    }
    else if (length > 30) {
        return {
            isValid : false,
            message : `Error: ${name} cannot exceed 30 characters in length.`
        }
    }
    else if (length >= 1 && length <= 30) {
        return {
            isValid : true,
            message : ""
        }
    }
}

export default validateName;


// WEBPACK FOOTER //
// ./src/helper/validateName.js